<template>
    <span class="chat-message-edit">
        <button
            v-if="canEdit"
            type="button"
            class="chat-message-edit__btn"
            title="Редактировать"
            @click="open"
        >
            ✎
        </button>

        <div
            ref="modalRoot"
            class="chat-message-edit-modal"
        >
            <CModal
                title="Редактировать сообщение"
                :show.sync="visible"
                :footer="false"
            >
                <template>
                    <div slot="body-wrapper" class="modal-body">
                        <CTextarea
                            v-model="draft"
                            rows="5"
                            :disabled="saving"
                        />
                    </div>
                    <div slot="footer">
                        <CButton
                            color="light"
                            class="ml-3"
                            :disabled="saving"
                            @click="visible = false"
                        >
                            Отмена
                        </CButton>
                        <CButton
                            color="primary"
                            class="ml-3"
                            :disabled="saving || !canSave"
                            @click="save"
                        >
                            {{ saving ? 'Сохраняем...' : 'Сохранить' }}
                        </CButton>
                    </div>
                </template>
            </CModal>
        </div>
    </span>
</template>

<script>
    export default {
        name: 'ChatMessageEdit',
        props: {
            message: {
                type: Object,
                required: true
            },
            canEdit: {
                type: Boolean,
                default: false
            },
            saving: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                visible: false,
                draft: ''
            };
        },
        computed: {
            canSave() {
                return Boolean(String(this.draft || '').trim());
            }
        },
        mounted() {
            if (this.$refs.modalRoot && this.$refs.modalRoot.parentNode !== document.body) {
                document.body.appendChild(this.$refs.modalRoot);
            }
        },
        beforeDestroy() {
            if (this.$refs.modalRoot && this.$refs.modalRoot.parentNode) {
                this.$refs.modalRoot.parentNode.removeChild(this.$refs.modalRoot);
            }
        },
        methods: {
            open() {
                if (!this.canEdit) {
                    return;
                }
                this.draft = String(this.message.message || '');
                this.visible = true;
            },
            save() {
                const text = String(this.draft || '').trim();
                if (!text || this.saving) {
                    return;
                }
                this.$emit('save', {
                    messageId: this.message.id,
                    message: text,
                    done: ok => {
                        if (ok) {
                            this.visible = false;
                        }
                    }
                });
            }
        }
    };
</script>

<style scoped>
.chat-message-edit__btn {
    border: 0;
    background: transparent;
    color: inherit;
    opacity: 0.95;
    padding: 0 0 0 6px;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    font-weight: 700;
    text-shadow: 0 0 1px rgba(0, 0, 0, 0.35);
}

.chat-message-edit__btn:hover {
    opacity: 1;
    transform: scale(1.08);
}
</style>

<style>
.chat-message-edit-modal .modal {
    z-index: 2000;
    padding-top: 72px;
}

.chat-message-edit-modal .modal-dialog {
    margin-top: 16px;
}

.chat-message-edit-modal .modal-backdrop {
    z-index: 1990;
}
</style>
